export default __webpack_public_path__ + "static/media/AstronomySaturn_05.0cbd4c41.png";